import UserResourcePagingResultModel from '../../generated/types/model/resource/UserResourcePagingResultModel';

export default class UserResourcePagingResultViewModel extends UserResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
